(() => {
  'use strict';
  const selector = '.appstle_sub_widget .appstle_subscription_amount';
  const spacing = '[ \\u00a0\\u202f]*';
  const number = '(?:\\d{1,3}(?:[ \\u00a0\\u202f,.]\\d{3})+|\\d+)(?:[.,]\\d{2})?';
  const currency = '(?:CA\\$|US\\$|C\\$|\\$|CAD|USD|€|EUR|£|GBP)';
  const price = new RegExp(`^(?:${currency}${spacing}${number}|${number}${spacing}${currency})$`, 'u');

  const fix = () => {
    document.querySelectorAll(selector).forEach(element => {
      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const text = node.nodeValue;
        if (!text || text.length > 100) continue;
        const repeated = text.trim().match(/^(.+?)\s*\1$/u);
        if (repeated && price.test(repeated[1])) node.nodeValue = repeated[1];
      }
    });
  };

  let queued = false;
  const observer = new MutationObserver(records => {
    const affected = records.some(record => {
      const element = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      if (element?.closest('.appstle_sub_widget')) return true;
      return [...record.addedNodes].some(node => node.nodeType === 1
        && (node.matches('.appstle_sub_widget') || node.querySelector('.appstle_sub_widget')));
    });
    if (!affected || queued) return;
    queued = true;
    queueMicrotask(() => { queued = false; fix(); });
  });

  const start = () => {
    fix();
    observer.observe(document.documentElement, { childList: true, characterData: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
